import { tv } from "tailwind-variants";
const otpInputVariants = tv({
  slots: {
    inputContainer: "gap-4",
    input: "border-[1px] border-slate-300 rounded-lg min-h-5xl size-0 px-xl py-sm items-center gap-2 min-w-20 focus-visible:border-blue-600 focus-visible:outline-blue-600 outline-0 caret-blue-600"
  },
  variants: {
    isInvalid: {
      true: {
        input: "!border-red-500 !caret-red-500"
      }
    }
  }
});
export {
  otpInputVariants as default
};
